const TrackingTypes = [
    {key: "load", text: "Loading", color: '#a4262c'},
    {key: "truck", text: "Trucking", color: '#d29200'},
    {key: "ship", text: "Shipping", color: '#0078d4'},
    {key: "train", text: "Train", color: '#107C10'},
    {key: "unload", text: "Unloading", color: '#a4262c'},
    {key: "other", text: "Others", color: '#C8C6C4'}
];

export default TrackingTypes;